import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

import { formatDate } from "../../../utilities/common";
import { useHouseState } from "../../../contexts/HouseContext";

export function GameHeader({ game, onClick }) {
    const navigate = useNavigate();
    const { house } = useHouseState();

    return (
        <header className="ledger-mast">
            <div>
                <button className="ledger-mast-back" onClick={() => navigate(-1)}>
                    Back to games
                </button>
                <h1>{renderTitle(game.description)}</h1>
                <div className="ledger-mast-meta">
                    {[house?.description, formatDate(game.date)].filter(Boolean).join(' · ')}
                </div>
            </div>
            <div className="ledger-mast-actions">
                <button className="btn" onClick={onClick}>
                    + Add player
                </button>
            </div>
        </header>
    );
}

// Mirror the dashboard treatment — italicize the last word of a
// multi-word description so it picks up the accent color.
function renderTitle(description) {
    if (!description) return <em>Untitled</em>;
    const trimmed = description.trim();
    const idx = trimmed.lastIndexOf(' ');
    if (idx === -1) return trimmed;
    return (
        <>
            {trimmed.slice(0, idx)} <em>{trimmed.slice(idx + 1)}</em>
        </>
    );
}

GameHeader.propTypes = {
    game: PropTypes.object,
    onClick: PropTypes.func,
};
